export default __webpack_public_path__ + "static/media/government.5da4171f.jpeg";